import { UPDATE_ANALYTICS_CLICK_EVENT } from '../actionTypes/CartActionTypes';

export const updateAnalyticsClickAction = (payload) => ({
    // NOSONAR
    type: UPDATE_ANALYTICS_CLICK_EVENT,
    payload,
});

export default { updateAnalyticsClickAction }; // NOSONAR
